import { createSelector } from "reselect";
import { AppState } from "app/shared/store/root.reducer";

const getBeneStore = (state: AppState) => state.beneficiaries;
const getListBene = (state: AppState) => state.beneficiaries.listBene;
const getPending = (state: AppState) => state.beneficiaries.pending;
const getAddSuccess = (state: AppState) => state.beneficiaries.addSuccess;

export const getBeneStoreSelector = createSelector(getBeneStore, (data) => data);
export const getListBeneSelector = createSelector(getListBene, (bene) => bene);
export const getPendingBeneSelector = createSelector(getPending, (status) => status);
export const getBeneAddSuccessSelector = createSelector(getAddSuccess, (status) => status);
